"use strict";
function n(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
export {
  n as default
};
//# sourceMappingURL=index.es175.js.map
